import { tryCatchHelper } from '../../../../helpers';
import {
  ACTIVO_ENTHOR_DIAS,
  ALL_ENTHOR_DIAS,
  LOADING_ALL_ENTHOR_DIAS,
} from './EntHorDiasReducer';
import {
  allEntHorDiasService,
  deleteEntHorDiasService,
  oneEntHorDiasService,
  saveEntHorDiasService,
} from './EntHorDiasService';

export const allEntHorDiasAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_ENTHOR_DIAS, payload: true });
    const res = await allEntHorDiasService(params);
    dispatch({ type: ALL_ENTHOR_DIAS, payload: res.data });
    dispatch({ type: LOADING_ALL_ENTHOR_DIAS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_ENTHOR_DIAS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveEntHorDiasAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveEntHorDiasService(id, data);
    notify(res.data.message);
    await allEntHorDiasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoEntHorDiasAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_ENTHOR_DIAS, payload: data });
};

export const oneEntHorDiasAction = async (dispatch, id) => {
  try {
    const res = await oneEntHorDiasService(id);
    await setActivoEntHorDiasAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteEntHorDiasAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteEntHorDiasService(id);
    notify(res.data.message);
    await setActivoEntHorDiasAction(dispatch, null);
    await allEntHorDiasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
